import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/plt.svg'


const _withScopeId = n => (_pushScopeId("data-v-626b38d9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Menu", -1))
const _hoisted_5 = { class: "menu" }

import { inject, ref, Ref } from "vue";
import { Menu } from "@element-plus/icons";
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const drawer: Ref<boolean> = inject("drawer");
const direction = ref("ltr");
const router = useRouter();

const blockChainRoutes = ["Blocks", "Txs", "Accounts", "Validators"];
const tokenRoutes = ["PLT", "ERC-20", "ERC-721", "ERC-1155"];

const navigateTo = (name) => {
  router.push({
    name: name,
  });
  drawer.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "logo",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateTo('Home')))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("header.title")), 1)
    ]),
    _createVNode(_component_el_icon, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = true))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Menu)),
        _hoisted_4
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_el_drawer, {
        modelValue: _unref(drawer),
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_isRef(drawer) ? (drawer).value = $event : null)),
        "with-header": false,
        direction: direction.value,
        size: "50%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu, { "default-openeds": ['1', '2'] }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, {
                index: "0",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (navigateTo('Home')))
              }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.home")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "1" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.blockchain")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: "1-1",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (navigateTo(blockChainRoutes[0])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.blocks")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "1-2",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (navigateTo(blockChainRoutes[1])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.transactions")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "1-3",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (navigateTo(blockChainRoutes[2])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.accounts")), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "1-4",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (navigateTo(blockChainRoutes[3])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("header.validators")), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "2" }, {
                title: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.token")), 1)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, {
                    index: "2-1",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (navigateTo(tokenRoutes[0])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tokenRoutes[0]), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "2-2",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (navigateTo(tokenRoutes[1])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tokenRoutes[1]), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "2-3",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (navigateTo(tokenRoutes[2])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tokenRoutes[2]), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, {
                    index: "2-4",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (navigateTo(tokenRoutes[2])))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tokenRoutes[3]), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue", "direction"])
    ])
  ]))
}
}

})